function o(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
export {
  o as default
};
//# sourceMappingURL=iterableToArray.js.map
